import api from './api';
import { Notification } from '../types';

export const notificationService = {
    getAll: async () => {
        const res = await api.get('/notifications');
        return res.data;
    },

    markAsRead: async (id: string) => {
        const res = await api.put(`/notifications/${id}/read`);
        return res.data;
    },

    markAllAsRead: async () => {
        const res = await api.put('/notifications/read-all');
        return res.data;
    },

    delete: async (id: string) => {
        const res = await api.delete(`/notifications/${id}`);
        return res.data;
    },

    getUnreadCount: async () => {
        const res = await api.get('/notifications/unread-count');
        return res.data.count;
    }
};
